import type { FunctionComponent } from "react";
import { Button } from "../../ui/button";
import { useToast } from "../../../hooks/use-toast";
import { handleHttpError } from "../../../utils/utils";
import type { IPayoutTransactionMinimal } from "../../../types/models/payout-transaction.modals.types";
import { usePayoutApproveAdminHttp } from "../../../hooks/http/admin/payouts/payout-approve.admin.http";
import Spinner from "../../spinner.components";

type AppProps = {
	removeById: (id: string) => void;
	payout: IPayoutTransactionMinimal;
	className?: string;
};

export const ApproveButton: FunctionComponent<AppProps> = ({
	payout,
	removeById,
	className,
}) => {
	const { execute: approvePayoutHttp, fetching: fetchingApprove } =
		usePayoutApproveAdminHttp();

	const { toast } = useToast();

	const handleApprove = async () => {
		const response = await approvePayoutHttp({
			pathParams: { id: payout.id },
			body: null,
		});

		if (!response.success) {
			return handleHttpError(response, toast);
		}
		removeById(payout.id);
	};

	return (
		<Button
			disabled={fetchingApprove}
			onClick={handleApprove}
			className={`border-approvebuttonborder w-24 h-10 bg-approvebuttonbg border font-semibold text-approvebuttontext tracking-wider ${className}`}
		>
			{fetchingApprove ? <Spinner width={15} /> : "Approve"}
		</Button>
	);
};
